import type { SchedulePaymentsApi } from '@/src/experiences/card-payments/store/api'

type PaymentProfile =
  (typeof SchedulePaymentsApi.endpoints)['GET /card/:cardAccountId/payments/methods']['Types']['ResultType']['profiles'][number]

export function formatPaymentProfile(paymentProfile: PaymentProfile) {
  return paymentProfile.plaidAccount
    ? [
        [paymentProfile.plaidAccount.item.institution.name, paymentProfile.plaidAccount.subtype]
          .join(' ')
          .trim() || paymentProfile.plaidAccount.name,
        paymentProfile.plaidAccount.mask,
      ]
        .filter((s) => typeof s === 'string')
        .filter((s) => s)
        .join(' ')
    : undefined
}
